import { render, staticRenderFns } from "./SelectDepartmentModal.vue?vue&type=template&id=61da7336"
import script from "./SelectDepartmentModal.vue?vue&type=script&lang=js"
export * from "./SelectDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./SelectDepartmentModal.vue?vue&type=style&index=0&id=61da7336&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports